

// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav, Offcanvas } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaClipboardList, FaDatabase, FaTasks, FaBriefcase, FaChartBar, FaSignInAlt, FaLeaf, FaCloudRain } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import '../../assets/styles/Navbar.css';
import logo from '../../assets/images/operamich.png';

const NavigationBar = () => {
  const { logout } = useAuth();
  const [role, setRole] = useState(localStorage.getItem('role') || sessionStorage.getItem('role'));
  const [userName, setUserName] = useState(localStorage.getItem('userName') || sessionStorage.getItem('userName'));
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getNavItemClass = (path) => {
    const active = location.pathname === path;
    return `nav-item-link${active ? ' active' : ''}`;
  };

  useEffect(() => {
    // Actualizar el estado cuando cambie el localStorage
    const handleStorageChange = () => {
      setRole(localStorage.getItem('role') || sessionStorage.getItem('role'));
      setUserName(localStorage.getItem('userName') || sessionStorage.getItem('userName'));
    };

    // Verificar una vez al montar el componente
    handleStorageChange();

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const closeMenu = () => setShowMenu(false);

  const handleBrandClick = () => {
    closeMenu();
    navigate('/registro-operario');
  };

  return (
    <Navbar className="custom-navbar" expand={false}>
      <Container>

        <button
          className={`burger ${showMenu ? 'open' : ''}`}
          aria-label="Abrir menú"
          onClick={() => setShowMenu(true)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <Offcanvas show={showMenu} onHide={closeMenu} placement="start" className="menu-drawer">
          <Offcanvas.Header closeButton closeVariant="white" className="drawer-header">
            <div className="drawer-title">
              <div className="drawer-brand" role="button" tabIndex={0} onClick={handleBrandClick} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { handleBrandClick(); } }}>
                <img src={logo} alt="Operamich" />
                <span>Operamich</span>
              </div>
              <div className="drawer-greeting">
                {userName ? `Hola, ${userName}` : 'Menú'}
              </div>
            </div>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="flex-column menu-list">
              {role === 'Admin' && (
                <React.Fragment>
                  <LinkContainer to="/registro-operario">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/registro-operario')}>
                      <FaHome className="nav-icon" /> Inicio
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/plan-operativo">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/plan-operativo')}>
                      <FaLeaf className="nav-icon" /> Plan Operativo
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/plan-operativo/resumen">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/plan-operativo/resumen')}>
                      <FaChartBar className="nav-icon" /> Resumen Mensual
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/dashboard">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/dashboard')}>
                      <FaChartBar className="nav-icon" /> Reporte Mes
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/precipitacion">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/precipitacion')}>
                      <FaCloudRain className="nav-icon" /> Precipitación
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/database">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/database')}>
                      <FaClipboardList className="nav-icon" /> Registros
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/usuarios">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/usuarios')}>
                      <FaDatabase className="nav-icon" /> Base de Datos
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/actividades">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/actividades')}>
                      <FaTasks className="nav-icon" /> Actividades
                    </Nav.Link>
                  </LinkContainer>
                </React.Fragment>
              )}

              {role === 'Gestor' && (
                <React.Fragment>
                  <LinkContainer to="/registro-operario">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/registro-operario')}>
                      <FaHome className="nav-icon" /> Inicio
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/plan-operativo">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/plan-operativo')}>
                      <FaLeaf className="nav-icon" /> Plan Operativo
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/plan-mensual">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/plan-mensual')}>
                      <FaClipboardList className="nav-icon" /> Plan Mensual
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/vergel">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/vergel')}>
                      <FaLeaf className="nav-icon" /> El Vergel
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/precipitacion">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/precipitacion')}>
                      <FaCloudRain className="nav-icon" /> Precipitación
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/database">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/database')}>
                      <FaClipboardList className="nav-icon" /> Registros
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/usuarios">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/usuarios')}>
                      <FaDatabase className="nav-icon" /> Base de Datos
                    </Nav.Link>
                  </LinkContainer>
                </React.Fragment>
              )}

              {role === 'Supervisor' && (
                <React.Fragment>
                  <LinkContainer to="/registro-operario">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/registro-operario')}>
                      <FaHome className="nav-icon" /> Inicio
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/supervisor">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/supervisor')}>
                      <FaClipboardList className="nav-icon" /> Mis Registros
                    </Nav.Link>
                  </LinkContainer>
                </React.Fragment>
              )}



              {role === 'Lider' && (
                <React.Fragment>
                  <LinkContainer to="/registro-operario">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/registro-operario')}>
                      <FaHome className="nav-icon" /> Inicio
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/plan-operativo">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/plan-operativo')}>
                      <FaLeaf className="nav-icon" /> Plan Operativo
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/plan-mensual">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/plan-mensual')}>
                      <FaClipboardList className="nav-icon" /> Plan Mensual
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/vergel">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/vergel')}>
                      <FaLeaf className="nav-icon" /> El Vergel
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/precipitacion">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/precipitacion')}>
                      <FaCloudRain className="nav-icon" /> Precipitación
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/database">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/database')}>
                      <FaClipboardList className="nav-icon" /> Registros
                    </Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/usuarios">
                    <Nav.Link onClick={closeMenu} className={getNavItemClass('/usuarios')}>
                      <FaDatabase className="nav-icon" /> Base de Datos
                    </Nav.Link>
                  </LinkContainer>
                </React.Fragment>
              )}
            </Nav>

            <div className="menu-footer">
              {userName ? (
                <button className="logout-btn" onClick={() => { closeMenu(); logout(); }}>
                  Cerrar Sesión
                </button>
              ) : (
                <LinkContainer to="/login">
                  <Nav.Link onClick={closeMenu} className={getNavItemClass('/login')}>
                    <FaSignInAlt className="nav-icon" /> Iniciar Sesión
                  </Nav.Link>
                </LinkContainer>
              )}
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;